import React, { Suspense } from 'react';
import dynamic from 'next/dynamic';
import Container from '@mui/material/Container';
import * as Sentry from '@sentry/nextjs';

import ErrorPage from './error-page';

const Loader = dynamic(() => import('@internal/components/common/loader'));

const Page: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Sentry.ErrorBoundary
    fallback={
      <Container maxWidth="md" sx={{ my: 4 }}>
        <ErrorPage
          title="service temporarily unavailable"
          text="// no panic! our servers got tired, but will be back on track soon. working on it 🙌"
        />
      </Container>
    }
  >
    <Suspense fallback={<Loader open />}>{children}</Suspense>
  </Sentry.ErrorBoundary>
);

export default Page;
